import { CommonEntrypoint } from "entrypoint/CommonEntrypoint";
import TariffMappingContMain from "presentation/view/container/TariffMapping/TariffMappingContMain";

CommonEntrypoint(<TariffMappingContMain/>)